/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <!-- Left: switcher + checklist -->
      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='r1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r1'">R1</vs-button>
          <vs-button :color="sel==='r2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r2'">R2</vs-button>
          <vs-button :color="sel==='r3'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r3'">R3</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 (R2) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">NAT Configuration — R2</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Items.filter(i=>r2Completion[i.key]).length }}/{{ task1Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task1Items" :key="'t1-'+item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r2Completion[item.key]?'#28C76F':'transparent',border:'2px solid '+(r2Completion[item.key]?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="r2Completion[item.key]?'text-success':''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Task 2 (R3 only) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">DHCP Client — R3</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Items.filter(i=>r3Completion[i.key]).length }}/{{ task2Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task2Items" :key="'t2-'+item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r3Completion[item.key]?'#28C76F':'transparent',border:'2px solid '+(r3Completion[item.key]?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="r3Completion[item.key]?'text-success':''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Task 3 (R1 + R2) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">NTP Configuration</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="rKey in ['r1','r2']" :key="'t3-'+rKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ rKey.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in (rKey==='r1'?task3R1Items:task3R2Items)" :key="rKey+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getCompletion(rKey)[item.key]?'#28C76F':'transparent',border:'2px solid '+(getCompletion(rKey)[item.key]?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getCompletion(rKey)[item.key]?'text-success':''">{{ item.cmd }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 4 (R3) -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task4Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task4Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task4Done?'#28C76F':'#4a5568'}">4</span>
              <span class="font-semibold text-sm flex-1">SSH Configuration — R3</span>
              <span class="text-xs font-medium" :class="task4Done?'text-success':'text-grey'">{{ task4Items.filter(i=>r3Completion[i.key]).length }}/{{ task4Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task4Items" :key="'t4-'+item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:r3Completion[item.key]?'#28C76F':'transparent',border:'2px solid '+(r3Completion[item.key]?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="r3Completion[item.key]?'text-success':''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Verification -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(verifyDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:verifyDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="verifyDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="verifyDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Verification</span>
              <span class="text-xs font-medium" :class="verifyDone?'text-success':'text-grey'">{{ verifyItems.filter(i=>getCompletion(i.router)[i.key]).length }}/{{ verifyItems.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in verifyItems" :key="'v-'+item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getCompletion(item.router)[item.key]?'#28C76F':'transparent',border:'2px solid '+(getCompletion(item.router)[item.key]?'#28C76F':'#6b7280')}"></div>
                <code class="text-base" :class="getCompletion(item.router)[item.key]?'text-success':''">{{ item.cmd }}</code>
                <span class="text-xs text-grey ml-auto">{{ item.router.toUpperCase() }}</span>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ [r1Completion.saved,r2Completion.saved,r3Completion.saved].filter(Boolean).length }}/3</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="rKey in ['r1','r2','r3']" :key="'s-'+rKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ rKey.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:isReadyForSave(rKey)?'#28C76F':'transparent',border:'2px solid '+(isReadyForSave(rKey)?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="isReadyForSave(rKey)?'text-success':''">end</code>
                  </div>
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getCompletion(rKey).saved?'#28C76F':'transparent',border:'2px solid '+(getCompletion(rKey).saved?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getCompletion(rKey).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <!-- Right: Terminals -->
      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='r1'" key="r1" id="r1_terminal" :commands="r1Commands" :prompt="r1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R1" />
          <vue-command v-show="sel==='r2'" key="r2" id="r2_terminal" :commands="r2Commands" :prompt="r2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R2" />
          <vue-command v-show="sel==='r3'" key="r3" id="r3_terminal" :commands="r3Commands" :prompt="r3Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R3" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist.';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/IP_Services_Sim_Version2.png',
      sel: 'r2',
      totalScore: 0,

      task1Items: [
        { key: 'aclCreated',      cmd: 'ip access-list standard XLATE' },
        { key: 'aclPermit1',      cmd: 'permit 10.2.3.3' },
        { key: 'aclPermit2',      cmd: 'permit 192.168.3.1' },
        { key: 'aclPermit3',      cmd: 'permit 10.1.3.11' },
        { key: 'aclExited',       cmd: 'exit' },
        { key: 'intE01',          cmd: 'interface e0/1' },
        { key: 'natInsideE01',    cmd: 'ip nat inside' },
        { key: 'intE00',          cmd: 'interface e0/0' },
        { key: 'natOutsideE00',   cmd: 'ip nat outside' },
        { key: 'natPool',         cmd: 'ip nat pool test_pool 10.10.10.1 10.10.10.254 netmask 255.255.255.0' },
        { key: 'natInsideSource', cmd: 'ip nat inside source list XLATE pool test_pool' },
      ],
      task2Items: [
        { key: 'intE02',  cmd: 'interface e0/2' },
        { key: 'e02Dhcp', cmd: 'ip address dhcp' },
      ],
      task3R1Items: [
        { key: 'ntpMaster', cmd: 'ntp master 1' },
      ],
      task3R2Items: [
        { key: 'ntpClient', cmd: 'ntp server 10.1.2.1' },
      ],
      task4Items: [
        { key: 'vtyConfig',    cmd: 'line vty 0 4' },
        { key: 'transportSSH', cmd: 'transport input ssh' },
        { key: 'loginLocal',   cmd: 'login local' },
        { key: 'vtyExited',    cmd: 'exit' },
        { key: 'username',     cmd: 'username root password s3cret' },
        { key: 'cryptoKey',    cmd: 'crypto key generate rsa modulus 1024' },
      ],
      verifyItems: [
        { router: 'r3', key: 'verifyPing',    cmd: 'ping 192.168.100.1' },
        { router: 'r3', key: 'verifyBrief',   cmd: 'show ip interface brief' },
        { router: 'r2', key: 'verifyShowNtp', cmd: 'show ntp status' },
        { router: 'r1', key: 'verifySSH',     cmd: 'ssh -l root 10.1.3.11' },
      ],

      r1: { mode: 'exec', currentInterface: null, endDone: false },
      r2: { mode: 'exec', currentInterface: null, currentAcl: null, endDone: false },
      r3: { mode: 'exec', currentInterface: null, endDone: false },

      r1Completion: {
        ntpMaster: false, verifySSH: false, saved: false,
      },
      r2Completion: {
        aclCreated: false, aclPermit1: false, aclPermit2: false, aclPermit3: false, aclExited: false,
        intE01: false, natInsideE01: false, intE00: false, natOutsideE00: false,
        natPool: false, natInsideSource: false,
        ntpClient: false, verifyShowNtp: false, saved: false,
      },
      r3Completion: {
        intE02: false, e02Dhcp: false, verifyPing: false, verifyBrief: false,
        vtyConfig: false, transportSSH: false, loginLocal: false, vtyExited: false,
        username: false, cryptoKey: false, saved: false,
      },

      r1Commands: {
        help:      () => createStdout(HELP),
        enable:    () => createStdout(''),
        configure: (x) => this.iosConfigure(this.r1, x),
        conf:      (x) => this.iosConfigure(this.r1, x),
        exit:      () => this.iosExit('r1', this.r1Completion),
        end:       () => this.iosEnd('r1', this.r1Completion),
        ntp:       (x) => this.iosNtp('r1', this.r1Completion, x),
        ssh:       (x) => this.iosSsh(x),
        show:      (x) => this.iosShow('r1', this.r1Completion, x),
        copy:      (x) => this.iosCopy(this.r1, this.r1Completion, x),
      },
      r2Commands: {
        help:      () => createStdout(HELP),
        enable:    () => createStdout(''),
        configure: (x) => this.iosConfigure(this.r2, x),
        conf:      (x) => this.iosConfigure(this.r2, x),
        exit:      () => this.iosExit('r2', this.r2Completion),
        end:       () => this.iosEnd('r2', this.r2Completion),
        ip:        (x) => this.r2IosIp(x),
        permit:    (x) => this.iosPermit(x),
        interface: (x) => this.iosInt('r2', this.r2Completion, x),
        int:       (x) => this.iosInt('r2', this.r2Completion, x),
        ntp:       (x) => this.iosNtp('r2', this.r2Completion, x),
        show:      (x) => this.iosShow('r2', this.r2Completion, x),
        copy:      (x) => this.iosCopy(this.r2, this.r2Completion, x),
      },
      r3Commands: {
        help:      () => createStdout(HELP),
        enable:    () => createStdout(''),
        configure: (x) => this.iosConfigure(this.r3, x),
        conf:      (x) => this.iosConfigure(this.r3, x),
        exit:      () => this.iosExit('r3', this.r3Completion),
        end:       () => this.iosEnd('r3', this.r3Completion),
        interface: (x) => this.iosInt('r3', this.r3Completion, x),
        int:       (x) => this.iosInt('r3', this.r3Completion, x),
        ip:        (x) => this.r3IosIp(x),
        line:      (x) => this.iosLine(x),
        transport: (x) => this.iosTransport(x),
        login:     (x) => this.iosLogin(x),
        username:  (x) => this.iosUsername(x),
        crypto:    (x) => this.iosCrypto(x),
        ping:      (x) => this.iosPing(x),
        show:      (x) => this.iosShow('r3', this.r3Completion, x),
        copy:      (x) => this.iosCopy(this.r3, this.r3Completion, x),
      },
    };
  },

  computed: {
    r1Prompt() {
      const m = this.r1.mode;
      if (m === 'config') return 'R1(config)#';
      if (m === 'config-if') return 'R1(config-if)#';
      return 'R1#';
    },
    r2Prompt() {
      const m = this.r2.mode;
      if (m === 'config') return 'R2(config)#';
      if (m === 'config-std-nacl') return 'R2(config-std-nacl)#';
      if (m === 'config-if') return 'R2(config-if)#';
      return 'R2#';
    },
    r3Prompt() {
      const m = this.r3.mode;
      if (m === 'config') return 'R3(config)#';
      if (m === 'config-if') return 'R3(config-if)#';
      if (m === 'config-line') return 'R3(config-line)#';
      return 'R3#';
    },
    task1Done() {
      const c = this.r2Completion;
      return c.aclCreated && c.aclPermit1 && c.aclPermit2 && c.aclPermit3 && c.aclExited &&
             c.natInsideE01 && c.natOutsideE00 && c.natPool && c.natInsideSource;
    },
    task2Done() {
      return this.r3Completion.intE02 && this.r3Completion.e02Dhcp;
    },
    task3Done() {
      return this.r1Completion.ntpMaster && this.r2Completion.ntpClient;
    },
    task4Done() {
      const c = this.r3Completion;
      return c.vtyConfig && c.transportSSH && c.loginLocal && c.vtyExited && c.username && c.cryptoKey;
    },
    verifyDone() {
      return this.r3Completion.verifyPing && this.r3Completion.verifyBrief &&
             this.r2Completion.verifyShowNtp && this.r1Completion.verifySSH;
    },
    saveDone() { return this.r1Completion.saved && this.r2Completion.saved && this.r3Completion.saved; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
  },

  methods: {
    getState(rKey) { return this[rKey]; },
    getCompletion(rKey) { return this[rKey + 'Completion']; },

    modeErr(state, needed) {
      if (state.mode === needed) return null;
      if (needed === 'config') {
        if (state.mode === 'exec') return createStderr('% Must be in configuration mode — type "configure terminal" first');
        if (state.mode === 'config-if') return createStderr('% Must be in configuration mode — type "exit" to leave interface config first');
        if (state.mode === 'config-std-nacl') return createStderr('% Must be in configuration mode — type "exit" to leave ACL config first');
        if (state.mode === 'dhcp-config') return createStderr('% Must be in configuration mode — type "exit" to leave DHCP config first');
        if (state.mode === 'config-line') return createStderr('% Must be in configuration mode — type "exit" to leave line config first');
      }
      if (needed === 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" or "exit" first');
      if (needed === 'config-if') return createStderr('% Must be in interface config mode — type "interface [name]" first');
      if (needed === 'config-std-nacl') return createStderr('% Must be in ACL config mode — type "ip access-list standard [name]" first');
      if (needed === 'config-line') return createStderr('% Must be in line config mode — type "line vty 0 4" first');
      return createStderr('% Invalid input detected');
    },

    // Display-only: the "end" step is green once the user has actually issued
    // end/exit to return to privileged EXEC from a config mode — not just because
    // the router happens to start in exec mode. Not part of updateScore().
    isReadyForSave(rKey) {
      return this[rKey].endDone;
    },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    iosConfigure(state, x) {
      const me = this.modeErr(state, 'exec'); if (me) return me;
      if (x._[1] === 'terminal' || x._[1] === 't') {
        state.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(rKey, completion) {
      const state = this[rKey];
      switch (state.mode) {
        case 'config-std-nacl':
          if (completion.aclPermit1 && completion.aclPermit2 && completion.aclPermit3 && !completion.aclExited) {
            completion.aclExited = true; this.updateScore();
          }
          state.mode = 'config'; state.currentAcl = null; break;
        case 'dhcp-config':
          if (completion.dhcpNetwork && !completion.dhcpPoolExited) {
            completion.dhcpPoolExited = true; this.updateScore();
          }
          state.mode = 'config'; break;
        case 'config-line':
          if (completion.transportSSH && completion.loginLocal && !completion.vtyExited) {
            completion.vtyExited = true; this.updateScore();
          }
          state.mode = 'config'; break;
        case 'config-if': state.mode = 'config'; break;
        case 'config':    state.mode = 'exec'; state.endDone = true; break;
      }
      return createStdout('');
    },

    iosEnd(rKey, completion) {
      const state = this[rKey];
      const wasConfig = state.mode !== 'exec';
      if (state.mode === 'config-std-nacl' && !completion.aclExited && completion.aclPermit1 && completion.aclPermit2 && completion.aclPermit3) {
        completion.aclExited = true; this.updateScore();
      }
      if (state.mode === 'config-line' && !completion.vtyExited && completion.transportSSH && completion.loginLocal) {
        completion.vtyExited = true; this.updateScore();
      }
      state.mode = 'exec';
      if (wasConfig) state.endDone = true;
      return createStdout('');
    },

    iosInt(rKey, completion, x) {
      const state = this[rKey];
      const me = this.modeErr(state, 'config'); if (me) return me;
      let _r1 = String(x._[1] || '');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) _r1 = _r1 + x._[2];
      const raw = _r1.toLowerCase()
      const iface = raw.replace(/^(gigabitethernet|ethernet|fastethernet|gi|fa|e|f)/, 'e');
      if (!iface || !iface.match(/^e\d+\/\d+/)) return createStderr('% Invalid interface');
      state.mode = 'config-if';
      state.currentInterface = iface;
      if (rKey === 'r2') {
        if (iface === 'e0/1' && !completion.intE01) { completion.intE01 = true; this.updateScore(); }
        if (iface === 'e0/0' && !completion.intE00) { completion.intE00 = true; this.updateScore(); }
      }
      if (rKey === 'r3' && iface === 'e0/2' && !completion.intE02) {
        completion.intE02 = true; this.updateScore();
      }
      return createStdout(this.guide(`Entered interface ${iface} configuration mode. Interface-level commands applied here affect only this port.`));
    },

    iosNtp(rKey, completion, x) {
      const state = this[rKey];
      const me = this.modeErr(state, 'config'); if (me) return me;
      if (rKey === 'r1' && x._[1] === 'master') {
        if (!completion.ntpMaster) { completion.ntpMaster = true; this.updateScore(); }
        return createStdout(this.guide('R1 configured as NTP master (stratum 1). R1 will serve time to NTP clients on the network. → Configure R2: "ntp server 10.1.2.1".'));
      }
      if (rKey === 'r2' && x._[1] === 'server') {
        if (!completion.ntpClient) { completion.ntpClient = true; this.updateScore(); }
        return createStdout(this.guide('R2 NTP client pointing to R1 (10.1.2.1). → Verify with "end" then "show ntp status" on R2.'));
      }
      return createStderr('% Invalid input detected');
    },

    r2IosIp(x) {
      const state = this.r2; const c = this.r2Completion;
      if (x._[1] === 'access-list' && x._[2] === 'standard') {
        const me = this.modeErr(state, 'config'); if (me) return me;
        const name = x._[3];
        state.mode = 'config-std-nacl'; state.currentAcl = name;
        if (name === 'XLATE' && !c.aclCreated) { c.aclCreated = true; this.updateScore(); }
        return createStdout(this.guide('Standard named ACL "XLATE" created. Standard ACLs match only by source IP address. Mode is now R2(config-std-nacl)#. → Enter permit statements for each R3 source address.'));
      }
      if (x._[1] === 'nat' && x._[2] === 'inside' && x._[3] !== 'source') {
        const me = this.modeErr(state, 'config-if'); if (me) return me;
        if (state.currentInterface === 'e0/1' && !c.natInsideE01) { c.natInsideE01 = true; this.updateScore(); }
        return createStdout(this.guide('R2 e0/1 marked as NAT inside (LAN-facing). Packets arriving here will be subject to NAT translation. → "exit" then "interface e0/0" then "ip nat outside".'));
      }
      if (x._[1] === 'nat' && x._[2] === 'outside') {
        const me = this.modeErr(state, 'config-if'); if (me) return me;
        if (state.currentInterface === 'e0/0' && !c.natOutsideE00) { c.natOutsideE00 = true; this.updateScore(); }
        return createStdout(this.guide('R2 e0/0 marked as NAT outside (ISP-facing). Translated addresses exit through this interface. → "exit" then define NAT pool and NAT inside source.'));
      }
      if (x._[1] === 'nat' && x._[2] === 'pool') {
        const me = this.modeErr(state, 'config'); if (me) return me;
        if (x._[3] === 'test_pool' && !c.natPool) { c.natPool = true; this.updateScore(); }
        return createStdout(this.guide('NAT pool "test_pool" defined with range 10.10.10.1–10.10.10.254. This is the pool of public addresses R3 source IPs will be translated to. → "ip nat inside source list XLATE pool test_pool".'));
      }
      if (x._[1] === 'nat' && x._[2] === 'inside' && x._[3] === 'source') {
        const me = this.modeErr(state, 'config'); if (me) return me;
        if (x._[4] === 'list' && x._[5] === 'XLATE' && x._[6] === 'pool' && x._[7] === 'test_pool' && !c.natInsideSource) {
          c.natInsideSource = true; this.updateScore();
        }
        return createStdout(this.guide('NAT translation rule active — source addresses matching ACL XLATE will be translated to addresses from test_pool. → On R3: "end" then "ping 192.168.100.1" to verify.'));
      }
      return createStderr('% Invalid input detected');
    },

    r3IosIp(x) {
      const state = this.r3; const c = this.r3Completion;
      if (x._[1] === 'address' && x._[2] === 'dhcp') {
        const me = this.modeErr(state, 'config-if'); if (me) return me;
        if (state.currentInterface === 'e0/2' && !c.e02Dhcp) { c.e02Dhcp = true; this.updateScore(); }
        return createStdout('%DHCP-6-ADDRESS_ASSIGN: Interface Ethernet0/2 assigned DHCP address 10.1.3.11, mask 255.255.255.0, hostname R3' +
          this.guide('R3 e0/2 received 10.1.3.11 from the DHCP server. → Verify with "end" then "show ip interface brief".'));
      }
      return createStderr('% Invalid input detected');
    },

    iosPermit(x) {
      const me = this.modeErr(this.r2, 'config-std-nacl'); if (me) return me;
      const c = this.r2Completion; const addr = x._[1];
      let guideMsg = '';
      if (addr === '10.2.3.3'    && !c.aclPermit1) { c.aclPermit1 = true; this.updateScore(); guideMsg = 'ACE: permit 10.2.3.3 (R3 primary address). → "permit 192.168.3.1".'; }
      if (addr === '192.168.3.1' && !c.aclPermit2) { c.aclPermit2 = true; this.updateScore(); guideMsg = 'ACE: permit 192.168.3.1 (R3 secondary address). → "permit 10.1.3.11".'; }
      if (addr === '10.1.3.11'   && !c.aclPermit3) { c.aclPermit3 = true; this.updateScore(); guideMsg = 'ACE: permit 10.1.3.11 (R3 DHCP address). All R3 source IPs permitted. → "exit" then configure NAT pool and inside source.'; }
      return guideMsg ? createStdout(this.guide(guideMsg)) : createStdout('');
    },

    iosLine(x) {
      const me = this.modeErr(this.r3, 'config'); if (me) return me;
      if (x._[1] === 'vty') {
        this.r3.mode = 'config-line';
        if (!this.r3Completion.vtyConfig) { this.r3Completion.vtyConfig = true; this.updateScore(); }
        return createStdout(this.guide('VTY lines 0–4 entered. VTY lines control remote access (Telnet/SSH) to the router. → "transport input ssh" then "login local".'));
      }
      return createStdout('');
    },

    iosTransport(x) {
      const me = this.modeErr(this.r3, 'config-line'); if (me) return me;
      if (x._[1] === 'input' && x._[2] === 'ssh' && !this.r3Completion.transportSSH) {
        this.r3Completion.transportSSH = true; this.updateScore();
      }
      return createStdout(this.guide('VTY lines restricted to SSH only — Telnet disabled. → "login local".'));
    },

    iosLogin(x) {
      const me = this.modeErr(this.r3, 'config-line'); if (me) return me;
      if (x._[1] === 'local' && !this.r3Completion.loginLocal) {
        this.r3Completion.loginLocal = true; this.updateScore();
      }
      return createStdout(this.guide('VTY lines use local username database for authentication. → "exit" then "username root password s3cret".'));
    },

    iosUsername(x) {
      const me = this.modeErr(this.r3, 'config'); if (me) return me;
      const c = this.r3Completion;
      if (x._[1] === 'root' && x._[3] === 's3cret' && !c.username) {
        c.username = true; this.updateScore();
      }
      return createStdout(this.guide('User "root" created with local password. This account will be used to authenticate SSH sessions. → "crypto key generate rsa modulus 1024".'));
    },

    iosCrypto(x) {
      const me = this.modeErr(this.r3, 'config'); if (me) return me;
      if (x._[1] === 'key' && x._[2] === 'generate' && x._[3] === 'rsa') {
        const mod = x._[4] === 'modulus' ? parseInt(x._[5]) : (x._[4] === 'general-keys' ? parseInt(x._[6]) : null);
        if (mod >= 512 && !this.r3Completion.cryptoKey) {
          this.r3Completion.cryptoKey = true; this.updateScore();
        }
        return createStdout('% Generating RSA keys...<br>[OK] (elapsed time was 1 seconds)' +
          this.guide('RSA 1024-bit key pair generated. SSH server is now active on R3. → Verify from R1: "end" then "ssh -l root 10.1.3.11".'));
      }
      return createStderr('% Invalid input detected');
    },

    iosSsh(x) {
      const me = this.modeErr(this.r1, 'exec'); if (me) return me;
      if (x.l === 'root' && x._[1] === '10.1.3.11') {
        if (!this.r1Completion.verifySSH) { this.r1Completion.verifySSH = true; this.updateScore(); }
        return createStdout('Password:<br>R3>' + this.guide('SSH connection to R3 successful! User "root" authenticated via local database.'));
      }
      return createStderr('% Connection refused');
    },

    iosPing(x) {
      const me = this.modeErr(this.r3, 'exec'); if (me) return me;
      if (x._[1] === '192.168.100.1') {
        if (!this.r3Completion.verifyPing) { this.r3Completion.verifyPing = true; this.updateScore(); }
        return createStdout('Sending 5, 100-byte ICMP Echos to 192.168.100.1, timeout is 2 seconds:<br>.!!!!' +
          '<br>Success rate is 80 percent (4/5), round-trip min/avg/max = 1/1/1 ms' +
          this.guide('NAT verified — R3 can reach the internet. R2 is translating R3\'s source IP to an address from test_pool.'));
      }
      return createStdout(`Sending 5 ICMP Echos to ${x._[1]}...<br>.....<br>Success rate is 0 percent (0/5)`);
    },

    iosShow(rKey, completion, x) {
      const state = this[rKey];
      const me = this.modeErr(state, 'exec'); if (me) return me;
      if (x._[1] === 'ntp' && x._[2] === 'status') {
        if ('verifyShowNtp' in completion && !completion.verifyShowNtp) {
          completion.verifyShowNtp = true; this.updateScore();
        }
        return createStdout(
          'Clock is synchronized, stratum 2, reference is 10.1.2.1<br>' +
          'nominal freq is 250.0000 Hz, actual freq is 250.0000 Hz, precision is 2**10<br>' +
          'reference time is DE5B3B61.80000000 (00:00:01.500 UTC Tue Jan 1 2019)' +
          this.guide('R2 clock is synchronized with R1 (stratum 2, one hop from master). Stratum value increases by 1 per NTP hop away from the reference clock.')
        );
      }
      if (x._[1] === 'ip' && x._[2] === 'interface' && x._[3] === 'brief') {
        let out = 'Interface&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;IP-Address&nbsp;&nbsp;&nbsp;&nbsp;OK?&nbsp;Method&nbsp;Status&nbsp;&nbsp;&nbsp;Protocol<br>';
        if (rKey === 'r3') {
          out += 'Ethernet0/0&nbsp;&nbsp;&nbsp;10.2.3.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>';
          out += 'Ethernet0/1&nbsp;&nbsp;&nbsp;192.168.3.1&nbsp;&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>';
          out += `Ethernet0/2&nbsp;&nbsp;&nbsp;${completion.e02Dhcp ? '10.1.3.11' : 'unassigned'}&nbsp;&nbsp;&nbsp;YES&nbsp;${completion.e02Dhcp ? 'DHCP' : 'NVRAM'}&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>`;
          if ('verifyBrief' in completion && !completion.verifyBrief) {
            completion.verifyBrief = true; this.updateScore();
          }
          out += this.guide(completion.e02Dhcp ? 'R3 e0/2 shows 10.1.3.11 assigned via DHCP — DHCP client is working correctly.' : 'R3 e0/2 is unassigned — set "ip address dhcp" on e0/2 to request an address from R1\'s DHCP pool.');
        }
        return createStdout(out);
      }
      return createStderr('% Invalid input detected');
    },

    iosCopy(state, completion, x) {
      const me = this.modeErr(state, 'exec'); if (me) return me;
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!completion.saved) { completion.saved = true; this.updateScore(); }
        return createStdout('Building configuration...<br>[OK]' + this.guide('Configuration saved to NVRAM. Running-config holds active settings in RAM; startup-config persists them across reboots.'));
      }
      return createStderr('% Invalid input detected');
    },

    updateScore() {
      let score = 0;
      [this.r1Completion, this.r2Completion, this.r3Completion].forEach(c => {
        Object.values(c).forEach(v => { if (v) score++; });
      });
      this.totalScore = score;
      this.$emit('simulation_update_score', score);
      if (score >= 28) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#r1_terminal, #r2_terminal, #r3_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

